import React from 'react';
import styles from './css/index.module.css';

const DEFAULT_TOTAL_STEPS = 6;

const NewProjectWizardCard = ({
    step,
    totalSteps = DEFAULT_TOTAL_STEPS,
    title,
    subtitle,
    headerAside,
    children,
    onContinue,
    onCancel,
    onSkip,
    skipLabel = 'Skip for now',
    skipEnd = false,
    onBack,
    backLabel = 'Back',
    backInline = false,
    continueLabel = 'Continue',
    continueDisabled = false,
    continueLoading = false,
    wide = false,
    extraWide = false,
    irlWide = false,
    accessWide = false,
    formWide = false,
    hideProgress = false,
    hideFooter = false,
    flushBody = false,
    showHeaderDivider = false,
    hint,
}) => {
    const cardClass = irlWide
        ? `${styles.card} ${styles.cardIrlWide}`
        : extraWide
          ? `${styles.card} ${styles.cardExtraWide}`
          : formWide
            ? `${styles.card} ${styles.cardFormWide}`
            : accessWide
              ? `${styles.card} ${styles.cardAccessWide}`
              : wide
                ? `${styles.card} ${styles.cardWide}`
                : styles.card;
    const bodyClass = flushBody
        ? styles.cardBodySplit
        : hideFooter
          ? styles.cardBodyFlush
          : formWide
            ? styles.cardBodyForm
            : styles.cardBody;

    return (
        <div className={cardClass}>
            <div className={styles.cardHeader}>
                <div className={styles.headerTop}>
                    <div className={styles.headerCopy}>
                        <h1 className={styles.cardTitle}>{title}</h1>
                        {subtitle ? <p className={styles.cardSubtitle}>{subtitle}</p> : null}
                        {hint ? <p className={styles.cardHint}>{hint}</p> : null}
                    </div>
                    {headerAside}
                </div>
                {!hideProgress && step ? (
                    <div className={styles.stepProgress} aria-label={`Step ${step} of ${totalSteps}`}>
                        {Array.from({ length: totalSteps }, (_, index) => {
                            const isCurrent = index === step - 1;
                            const isComplete = index < step - 1;
                            const segmentClass = isCurrent
                                ? styles.stepSegmentActive
                                : isComplete
                                  ? styles.stepSegmentComplete
                                  : '';
                            return <div key={index} className={`${styles.stepSegment} ${segmentClass}`} />;
                        })}
                    </div>
                ) : null}
                {showHeaderDivider ? <div className={styles.headerDivider} /> : null}
            </div>
            <div className={bodyClass}>{children}</div>
            {!hideFooter ? (
                <div className={styles.cardFooter}>
                    <button
                        type="button"
                        className={`${styles.primaryButton} ${continueLoading ? styles.primaryButtonLoading : ''}`}
                        disabled={continueDisabled || continueLoading}
                        aria-busy={continueLoading || undefined}
                        onClick={onContinue}>
                        {continueLabel}
                        {continueLoading ? <span className={styles.buttonSpinner} aria-hidden="true" /> : null}
                    </button>
                    {onSkip && !skipEnd ? (
                        <button type="button" className={styles.ghostButton} disabled={continueLoading} onClick={onSkip}>
                            {skipLabel}
                        </button>
                    ) : onCancel && !onSkip ? (
                        <button type="button" className={styles.ghostButton} onClick={onCancel}>
                            Cancel
                        </button>
                    ) : null}
                    {onBack && backInline ? (
                        <button type="button" className={styles.ghostButton} onClick={onBack}>
                            {backLabel}
                        </button>
                    ) : null}
                    {(onSkip && skipEnd) || (onBack && !backInline) ? <div className={styles.footerSpacer} /> : null}
                    {onSkip && skipEnd ? (
                        <button type="button" className={styles.ghostButton} disabled={continueLoading} onClick={onSkip}>
                            {skipLabel}
                        </button>
                    ) : null}
                    {onBack && !backInline ? (
                        <button type="button" className={styles.ghostButton} onClick={onBack}>
                            {backLabel}
                        </button>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default NewProjectWizardCard;
